import { render, staticRenderFns } from "./DynamicVideoSet.vue?vue&type=template&id=65cf5332&"
import script from "./DynamicVideoSet.vue?vue&type=script&lang=js&"
export * from "./DynamicVideoSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports